import { Accordion, styled } from '@mui/material';

export const SignalGroupsList = styled('ul')(({ theme }) => ({
  height: '100%',
  listStyle: 'none',
  padding: 0,
  margin: 0,
  overflowY: 'auto',
  ...theme.styledScrollbar,
}));

export const SignalListItem = styled('li', {
  shouldForwardProp: prop => prop !== 'hasChip',
})(({ hasChip }) => ({
  display: 'grid',
  ...(hasChip && { gridTemplateColumns: '3fr 1fr' }),

  '.signal-chip': {
    display: 'flex',
    alignItems: 'center',

    '& .MuiChip-label': {
      textWrap: 'auto',
    },
  },
}));

export const SignalGroupAccordion = styled(Accordion, {
  shouldForwardProp: prop => prop !== 'index',
})(({ theme, index }) => ({
  ...(index !== 0 && {
    borderTop: theme.border.default,
  }),

  '&.MuiPaper-root': {
    borderRadius: 0,
  },

  '.MuiAccordionSummary-content': {
    margin: 0,
    padding: theme.spacing(1),
  },

  '&.Mui-expanded': {
    borderTop: 'none',

    '.MuiAccordionSummary-root': {
      margin: 0,
      backgroundColor: theme.palette.grey[100],
      border: theme.border.default,
      borderRadius: theme.border.radius,
      minHeight: '48px',
    },

    '.MuiAccordionSummary-content': {
      margin: 0,
      padding: theme.spacing(1),
    },
  },
}));

export const SignalsChecklist = styled('ul', {
  shouldForwardProp: prop => prop !== 'inAccordion',
})(({ theme, inAccordion }) => ({
  listStyle: 'none',
  margin: theme.spacing(1, 0),
  padding: 0,

  ...(inAccordion && {
    padding: theme.spacing(1.5, 4, 1.5, 4),
    borderLeft: theme.border.default,
  }),

  'li.select-all': {
    paddingLeft: theme.spacing(2),
    paddingBottom: theme.spacing(1.5),
    marginBottom: theme.spacing(1),
    borderBottom: theme.border.default,

    '.MuiCheckbox-root:hover': {
      backgroundColor: 'transparent',
    },

    '.MuiTypography-root': {
      fontSize: theme.typography.body2.fontSize,
      fontFamily: theme.typography.bold.fontFamily,
    },
  },
}));

export const SearchChecklist = styled('ul')(({ theme }) => ({
  listStyle: 'none',
  padding: 0,
  margin: 0,
  overflowY: 'auto',
  ...theme.styledScrollbar,
}));

export const LabelCounter = styled('span')(({ theme }) => ({
  backgroundColor: theme.palette.grey[100],
  border: theme.border.default,
  color: theme.palette.text.primary,
  fontFamily: theme.typography.bold.fontFamily,
  fontSize: '12px',
  borderRadius: '50%',
  height: '24px',
  width: '24px',
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  marginLeft: theme.spacing(1),
}));

export const GroupSignalCounter = styled('span')(({ theme }) => ({
  backgroundColor: theme.palette.success.light,
  border: `1px solid ${theme.palette.success.main}`,
  color: theme.palette.success.main,
  fontSize: '12px',
  fontFamily: theme.typography.caption.fontFamily,
  borderRadius: theme.border.radius,
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: theme.spacing(0.4, 1),
  marginLeft: theme.spacing(1),
}));
